import { DATEFNS_LOCALES } from '@Sage/ssm-utils';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/pt';

import { default as isDateFn } from 'date-fns/isDate';
import { default as dateFormat } from 'date-fns/format';
import { default as parseDateFormat } from 'date-fns/parse';
import { default as isValidFn } from 'date-fns/isValid';
import { formatDistanceStrict } from 'date-fns';

const DEFAULT_FORMAT = 'YYYY-MM-DDTHH:mm:SSS';
export const isValid = isValidFn;
export const LOCALE_DATES = DATEFNS_LOCALES;

export const setupMomentLocale = (locale = 'en') => {
    moment.locale(locale);
};

export const getLocaleDateTime = (date, format = DEFAULT_FORMAT) =>
    moment(date, format).format('L hh:mm');

export const getLocaleDate = (date, format = DEFAULT_FORMAT) => moment(date, format).format('L');

export function formatDate(date, locale = 'en-US', format = 'P p') {
    let d = date;
    if (!isDateFn(d)) d = new Date(date);
    return dateFormat(d, format, {
        locale: DATEFNS_LOCALES[locale],
    });
}

export function formatDateWithFormat(date, locale = 'en-US', formatIn = 'P p', formatOut = 'P p') {
    let d = date;
    const jsDate = parseDateFormat(d, formatIn, 0, { locale: DATEFNS_LOCALES[locale] });
    if (!isValid(jsDate)) return date;
    return formatDate(jsDate, locale, formatOut);
}

export const getTimeUntilNow = (date, locale = 'en-US') => {
    return formatDistanceStrict(new Date(date), new Date(), { locale: DATEFNS_LOCALES[locale] });
};
